import React, { useCallback, useReducer, createContext, useMemo } from 'react';

import { getPlaces, reverseGeocoding } from 'modules/point-of-interest/service';
import { createMapFromListOfVenues } from 'modules/point-of-interest/utils';

import reducer, { INIT_STATE, setVenues, setClear, setSelectedVenue } from './POIVenuesReducer';

const POIVenuesContext = createContext();

function POIVenuesContextProvider(props) {
  const [state, dispatch] = useReducer(reducer, INIT_STATE);

  const fetchVenues = useCallback(async (latLng) => {
    if (!latLng) {
      return;
    }
    const [latitude, longitude] = latLng;
    const responseVenues = await reverseGeocoding({ latitude, longitude });
    const ids = responseVenues?.features?.map((feature) => feature?.properties?.gid);
    const responsePlaces = ids ? await getPlaces(ids) : {};
    const venuesSet = createMapFromListOfVenues(responseVenues, responsePlaces);
    dispatch(setVenues(venuesSet));
  }, []);

  const clearVenues = useCallback(async () => {
    dispatch(setClear());
  }, []);

  const selectVenue = useCallback(async (venueId) => {
    dispatch(setSelectedVenue(venueId));
  }, []);

  const venues = useMemo(() => state.venues, [state.venues]);
  const selectedVenue = state.selectedVenue;

  const contextValue = {
    fetchVenues,
    clearVenues,
    selectVenue,
    selectedVenue,
    venues,
  };

  return (
    <POIVenuesContext.Provider value={contextValue}>{props.children}</POIVenuesContext.Provider>
  );
}

export { POIVenuesContext, POIVenuesContextProvider };
